<main class="container" *ngIf="trip_Obj">

    <!-- پرداخت موفقیت آمیز -->

    <section *ngIf="trip_Obj?.iResult == 1" class="success-container  border-2 rounded p-md-3 px-2">

        <!-- پیغام -->

        <div class="alert alert-success w-100 d-flex align-items-center justify-content-center" role="alert">

           <span class="fw-bold mx-1"> {{ trip_Obj?.strMessage }} </span>

        </div>

        <!-- توضیحات -->

        <div class="alert alert-success w-100" role="alert">

            <p class="fw-bold mx-1 " style="font-size: 13px;"> 
                
                مبلغ پرداخت شده :  {{ trip_Obj.iAmount | number: '1.0-0' | faNum}} ریال 
            
            </p>
            
            <p class="fw-bold mx-1 " style="font-size: 13px;"> 
                
                شماره تراکنش :  {{ trip_Obj.strRefId | faNum }}
            
            </p>


        </div>

    </section>

    <!-- پرداخت ناموفق -->

    <section *ngIf="trip_Obj?.iResult == 0" class="failed-container  border-2 rounded p-md-3 px-2">

        <!-- پرداخت ناموفق -->

        <div class="alert alert-danger w-100 d-flex align-items-center justify-content-center" role="alert">

            <span class="fw-bold mx-1"> {{ trip_Obj?.strMessage }} </span>
 
        </div>

        <!-- بازگشت وجه -->

        <div class="w-100 row gx-0 gy-0 px-2 alert alert-secondary" role="alert">

            <p class="refund-text fw-bold mb-0 text-muted col-12" style="font-size: 12px;line-height: 24px;"> 

                {{ trip_Obj.strError | faNum }}
                
            </p>

        </div>

        <!-- توضیحات -->

        <div class="alert alert-secondary w-100" role="alert">

            <p class="fw-bold mx-1 " style="font-size: 13px;"> مبلغ پرداخت شده :  
                
                <span class="text-muted">

                    {{ trip_Obj.iAmount | number: '1.0-0' | faNum }}
                                        
                </span>
            
            </p>

            <p class="fw-bold mx-1 " style="font-size: 13px;"> شماره تراکنش :  
                
                <span class="text-muted">

                    {{ trip_Obj.strRefId || 'نامشخص' | faNum }}
                                        
                </span>
            
            </p>


        </div>

    </section>

    <!--  -->

    <div class="mt-2 p-md-3 px-2 d-flex justify-content-center">

        <button class="btn btn-outline-danger w-100" (click)="openLink()">

            <a style="color: inherit;width: 100%;">

                بازگشت

            </a>
        
        </button>

        <ng-container *ngIf="bAndroid;else bWeb">

            <button class="btn btn-primary w-100 mt-1">

                <a class="text-white" [href]="return_SafeUrl(href_Android)">

                    بازگشت به اپلیکیشن (a)

                </a>
            
            </button>

        </ng-container>

    </div>

</main>